export const QUOTES_AGENTLIST_FETCH_SUCCESS = "QUOTES_AGENTLIST_FETCH_SUCCESS";
export const QUOTES_AGENTLIST_LOADING = "QUOTES_AGENTLIST_LOADING";
export const QUOTES_AGENTLIST_FETCH_FAILED = "QUOTES_AGENTLIST_FETCH_FAILED";

export const QUOTES_SG_MIGRATION_TABLE = "QUOTES_SG_MIGRATION_TABLE";
export const SHOW_HIDE_STANDARD_BANNER = 'SHOW_HIDE_STANDARD_BANNER';